// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ButtonController from "./button_controller";
import Carousel from "./carousel";
import CheckboxController from "./checkbox_controller";
import CompetitorsModalController from "./competitors_controller";
import CompetitorsTrendOverTimeChartController from "./competitors_trend_over_time_chart_controller";
import DownloadsController from "./downloads_controller";
import DropdownController from "./dropdown_controller";
import ElementDownloadController from "./element_download_controller";
import EnableActionButtonController from "./enable_action_button_controller";
import FormController from "./form_controller";
import GoalFormController from "./goal_form_controller";
import HideElementController from "./hide_element_controller";
import HomepageController from "./homepage_controller";
import KeyDecisionMakersController from "./key_decision_makers_controller";
import KeyDecisionMakersDownloadController from "./key_decision_makers_download_controller";
import LoadingOverlayController from "./loading_overlay_controller";
import ModalController from "./modal_controller";
import ModalRevealController from "./modal_reveal_controller";
import NotificationsController from "./notifications_controller";
import PopoverController from "./popover_controller";
import PopupController from "./popup_controller";
import RevealContentController from "./reveal_content_controller";
import SemiCircleDonutChartController from "./semi_circle_donut_chart_controller";
import ShareNoticeModalController from "./share_notice_modal_controller";
import TrendByBuyerChartController from "./trend_by_buyer_chart_controller";
import TrendOverTimeChartController from "./trend_over_time_chart_controller";


application.register("button", ButtonController);
application.register("carousel", Carousel);
application.register("checkbox", CheckboxController);
application.register("competitors-modal", CompetitorsModalController);
application.register("competitors-trend-over-time-chart", CompetitorsTrendOverTimeChartController);
application.register("downloads", DownloadsController);
application.register("dropdown", DropdownController);
application.register("element-download", ElementDownloadController);
application.register("form", FormController);
application.register("enable-action-button", EnableActionButtonController);
application.register("hide-element", HideElementController);
application.register("homepage", HomepageController);
application.register("key-decision-makers", KeyDecisionMakersController);
application.register("key-decision-makers-download", KeyDecisionMakersDownloadController);
application.register("loading-overlay", LoadingOverlayController);
application.register("modal", ModalController);
application.register("modal-reveal", ModalRevealController);
application.register("notifications", NotificationsController);
application.register("popover", PopoverController);
application.register("popup", PopupController);
application.register("reveal-content", RevealContentController);
application.register("semi-circle-donut-chart", SemiCircleDonutChartController);
application.register("share-notice-modal", ShareNoticeModalController);
application.register("trend-by-buyer-chart", TrendByBuyerChartController);
application.register("trend-over-time-chart", TrendOverTimeChartController);
application.register("goal-form", GoalFormController);
